/**
 * Created by Julio Perez on 10/1/2017.
 */

export const chartHeaderPrefix = "2016 ";
export const currentYear = "2016 ";
export const forecastYear = "2021 ";

export const chartHeaderSuffix = " Consumption";
export const chartLabel = "Top 25 Countries";





// WEBPACK FOOTER //
// ./src/app/shared/js/visapp-config.js